module.exports = __webpack_public_path__ + "img/CertificateOfParticipation.44ca6360.jpg";